import { FormControl, Select, styled } from '@mui/material';
import { propsFilter } from '@utils/propsFilter';
import { coreThemeColors } from '@youscience/theme';
import { CoreBox, CoreRadio } from '@youscience/core';

export const sxStyles = {
  sectionTitle: {
    fontSize: '1.125rem',
  },
  editBtnTooltip: {
    maxWidth: '78px',

    '&:hover': {
      cursor: 'pointer',
    },
  },
  disabledEditBtn: {
    borderRadius: '40px',
    fontSize: '0.813rem',

    '& > svg:first-of-type': {
      marginRight: '0.5rem',
    },
  },
};

export const StyledApplication = styled(CoreBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '1rem',
}));

export const StyledApplicationSection = styled(CoreBox, {
  shouldForwardProp: propsFilter(['isEdit']),
})<{ isEdit?: boolean }>(({ isEdit }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: isEdit ? '1rem' : '0.5rem',
}));

export const StyledApplicationFormControl = styled(FormControl)(() => ({
  alignSelf: 'stretch',
}));

export const StyledApplicationSelect = styled(Select)(() => ({
  alignSelf: 'stretch',
}));

export const StyledCardDivider = styled(CoreBox)(() => ({
  flex: 'none',
  alignSelf: 'stretch',
  border: `1px solid ${coreThemeColors.grey[300]}`,
}));

export const StyledApplicationScore = styled(CoreBox)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
}));

export const StyledApplicationScoreNumber = styled(CoreBox, {
  shouldForwardProp: propsFilter(['isSelected']),
})<{ isSelected?: boolean; isEdit?: boolean }>(({ isSelected }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around',
  backgroundColor: !isSelected ? coreThemeColors.common.white : coreThemeColors.primary.main,
  border: `1px solid ${coreThemeColors.grey[300]}`,
  borderRadius: '4px',
  color: !isSelected ? coreThemeColors.common.black : coreThemeColors.common.white,
  width: '40px !important',
  height: '40px !important',
  padding: 0,

  '&:hover': {
    backgroundColor: !isSelected && coreThemeColors.primary.containedHoverBackground,
    color: !isSelected && coreThemeColors.common.white,
  },
}));

export const StyledApplicationScoreRadio = styled(CoreRadio)(() => ({
  position: 'absolute',
  opacity: 0,
}));

export const StyledApplicationButtonGroup = styled(CoreBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  gap: '0.5rem',

  [theme.breakpoints.down('md')]: {
    alignSelf: 'stretch',
  },
}));
